'use client';

import { useEffect, useState } from 'react';

import Differentials from '@/components/differentials/differentials';
import { Footer } from '@/components/footer/footer';
import { Header } from '@/components/header';
import HeroCarousel from '@/components/hero/hero';
import ServicesModal from '@/components/modals/services_modal';
import OurServices from '@/components/ourservices/ourservices';
import LoginModal from '@/components/modals/login_modal';
import Whatsapp from '@/components/whatsapp/whatsapp';
import { WHATSAPP_LINK } from '@/constants/whatsapp';

export default function HomeClient() {
  const [showServicesModal, setShowServicesModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    // Track previous hash to detect changes
    let prevHash = window.location.hash;

    const checkHash = () => {
      const currentHash = window.location.hash;

      if (currentHash !== prevHash) {
        prevHash = currentHash;

        if (currentHash === '#adquira') {
          setShowServicesModal(true);
        } else if (currentHash === '#login') {
          setShowLoginModal(true);
        } else {
          setShowLoginModal(false);
          setShowServicesModal(false);
        }
      }
    };

    const interval = setInterval(checkHash, 200); // Poll every 200ms

    // Initial check on mount
    if (window.location.hash === '#adquira') {
      setShowServicesModal(true);
    }

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Header />
      <main className="mt-28 lg:mt-36 mx-0">
        <HeroCarousel />
        {/* <PartnerLogos /> */}
        {/* <Separator className="bg-[#E6E6E6] mx-8 w-auto h-[2px]" /> */}
        <OurServices />
        {/* <Blog /> */}
        {/* <NewsLetter /> */}
        <div className="display flex flex-col m-0 w-full bg-[#e6f0f8]">
          <Differentials />
          {/* <Testimonies /> */}
        </div>
      </main>
      <Footer />

      <Whatsapp page="home" link={WHATSAPP_LINK} />

      <ServicesModal
        isOpen={showServicesModal}
        onClose={() => {
          setShowServicesModal(false);

          if (window.location.hash === '#adquira') {
            window.location.hash = '';
          }
        }}
      />

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => {
          setShowLoginModal(false);

          if (window.location.hash === '#login') {
            window.location.hash = '';
          }
        }}
      />
    </>
  );
}
